import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Alert, Form } from '@themesberg/react-bootstrap';
import { END_POINT_PRINCIPAL } from '../const';
import { showSuccessToast } from '../utils/toast';
import EditFormLayout from '../components/EditFormLayout';
import RecordEditFeedback from '../components/RecordEditFeedback';
import RecordEditActions from '../components/RecordEditActions';
import useRecordEditor from '../hooks/useRecordEditor';

export const PrincipalEditForm = ({ principalId, onSuccess, onCancel, onSubmittingChange }) => {
  const editor = useRecordEditor({
    recordId: principalId, endpoint: END_POINT_PRINCIPAL, label: 'principal',
    onSuccess, onSubmittingChange,
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { name: editor.record?.name || '' },
    validationSchema: Yup.object({
      name: Yup.string().trim().required('Principal name is required'),
    }),
    onSubmit: editor.submit,
  });

  if (editor.loading || editor.loadError || !editor.record) {
    return <RecordEditFeedback loading={editor.loading} error={editor.loadError}
      label="principal" onRetry={editor.retry} onCancel={onCancel} />;
  }

  return (
    <Form noValidate onSubmit={formik.handleSubmit} aria-busy={formik.isSubmitting}>
      {formik.status && <Alert variant="danger">{formik.status}</Alert>}
      <Form.Group className="mb-3" controlId="edit-principal-name">
        <Form.Label>Principal Name <span className="text-danger">*</span></Form.Label>
        <Form.Control type="text" autoFocus disabled={formik.isSubmitting}
          {...formik.getFieldProps('name')}
          isInvalid={Boolean(formik.touched.name && formik.errors.name)} />
        <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
      </Form.Group>
      <RecordEditActions formik={formik} backTo="/principals" onCancel={onCancel} />
    </Form>
  );
};

export const EditPrincipalForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const handleSuccess = result => {
    showSuccessToast(result.message || 'Principal updated successfully.');
    navigate('/principals');
  };
  return (
    <EditFormLayout title="Edit Principal" subtitle="Update principal details" backTo="/principals">
      <PrincipalEditForm key={id} principalId={id} onSuccess={handleSuccess} />
    </EditFormLayout>
  );
};
